import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { LocaleProvider } from 'zarm';
import localesZhCN from 'zarm/lib/locale-provider/locale/zh_CN';
import Routes from './pages/routes';

const APP_DOM = document.getElementById('app');

ReactDOM.render(
  <LocaleProvider locale={localesZhCN}>
    <Routes />
  </LocaleProvider>,
  APP_DOM,
);
